import { map, Observable, OperatorFunction, switchMap } from "rxjs";

export function packWith<A,B>(project:(a:A)=>Observable<B>):OperatorFunction<A,[A,B]>{
	return switchMap(a=>project(a).pipe(map(b=><[A,B]>[a,b])));
}
